import { render, staticRenderFns } from "./k-field-bswitch.vue?vue&type=template&id=e26fdb7a"
import script from "./k-field-bswitch.vue?vue&type=script&lang=js"
export * from "./k-field-bswitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports